import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ProgressBar } from "./progress-bar";

interface OnboardingLayoutProps {
	leftContent: ReactNode;
	children: ReactNode;
	step: number;
	totalSteps?: number;
	showBack?: boolean;
	onBack?: () => void;
}

export function OnboardingLayout({ leftContent, children, step, totalSteps = 4, showBack = false, onBack }: OnboardingLayoutProps) {
	const { t } = useTranslation("onboarding");
	const navigate = useNavigate();

	const handleBack = () => {
		if (onBack) {
			onBack();
		} else {
			navigate(-1);
		}
	};

	return (
		<div className="flex min-h-screen">
			<div className="hidden md:flex md:w-1/2 relative overflow-hidden bg-linear-to-br from-blue-200 via-blue-300 to-blue-400">
				<div className="absolute inset-0 bg-linear-to-t from-black/10 to-transparent" />
				<div className="relative z-10 flex items-center justify-center w-full p-12">{leftContent}</div>
			</div>
			<div className="flex-1 flex flex-col p-6 md:p-12">
				<div className="flex items-center justify-between mb-8">
					{showBack ? (
						<button type="button" onClick={handleBack} className="flex items-center gap-1 text-sm text-foreground/50 hover:text-foreground">
							<ChevronLeft className="w-4 h-4" />
							{t("back")}
						</button>
					) : (
						<div />
					)}
					<div className="w-48">
						<ProgressBar step={step} totalSteps={totalSteps} />
					</div>
				</div>
				<div className="flex-1 flex items-center justify-center">
					<div className="w-full max-w-md">{children}</div>
				</div>
			</div>
		</div>
	);
}
